<div class="product-note">
  <p-divider></p-divider>
  @if (showNoteForCustomers()) {
    <p class="pb-2 font-bold">
      {{ 'PRODUCT.productionTimes' | translate }}
    </p>
    <p class="pb-2">
      {{ 'PRODUCT.noteForCustomers' | translate }}
    </p>
    <p class="pb-2">
      {{ 'PRODUCT.expeditedShipping' | translate }}
    </p>
  }
  <p>{{ 'PRODUCT.noteForFinalSale' | translate }}</p>
  <p-divider></p-divider>
</div>
